import { Accepts, Types } from "@citychallenge/common";
import { Inlet } from "../../reactive";
import { defineElement } from "../define-element";

export class StartLocationProps {
  @Inlet(Accepts.GeoLocation) public startLocation?: Types["GeoLocation"];
  @Inlet(Accepts.Image) public markerImage?: Types["Image"];

  @Inlet(Accepts.Number) public minimumStartDistance?: Types["Number"];
  @Inlet(Accepts.MarkdownText) public customText?: Types["MarkdownText"];
}

export const StartLocationDefinition = defineElement(
  "start-location",
  StartLocationProps,
  {
    versionRequired: "0.8.0",
  }
);
